import React, { useEffect } from "react";
import "./ContactPage.css";
import Iframe from "react-iframe";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';

const ContactPage = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact - Pravin Kanth</title>
        <meta name="description" content="Get in touch with me for collaboration or inquiries. Let's connect!" />
      </Helmet>
      <div className="contactpage-section">
        <div className="contactpage">
          <div className="form">
            <div className="back" onClick={handleClick}>
              <h2>Back</h2>
            </div>
            <div className="form-container">
              <h5 className="h5-contact">Contact</h5>
              {/* <h1 className="h1">r.pravinkanth653@gmail.com</h1> */}
              <p className="p">
                Like what you see? Have something you’d like to talk about?
                <br></br>
                Want to ask me a personal question?
              </p>

              <form
                onSubmit="submit"
                className="theform"
                name="Portfolio"
                method="post"
                data-netlify="true"
              >
                <input type="hidden" name="form-name" value="Portfolio" />
                <input
                  className="fullname"
                  name="Fullname"
                  placeholder="FULL NAME"
                  type="text"
                  required
                ></input>
                <input
                  className="fullname"
                  name="Email"
                  placeholder="EMAIL ADDRESS"
                  type="email"
                  required
                ></input>
                <textarea
                  className="fullname textarea"
                  name="Message"
                  rows="7"
                  placeholder="ASK ME SOMETHING"
                ></textarea>
                <button type="submit" className="button">
                  send
                </button>
              </form>
            </div>
          </div>
          <div className="map">
            <Iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d71011.09854797072!2d77.138697682492!3d11.107925995551232!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8ffcb711accab%3A0x434cbe20e94cf8de!2sKarumathampatti%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1733684961288!5m2!1sen!2sin"
              width="600"
              className="frame"
              height="750"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></Iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
